import React from 'react';
import MenuCV from './controladorVista/menuCV';

const Menu: React.FunctionComponent = () => <MenuCV />;

export default Menu;
